// extracted by mini-css-extract-plugin
export default {"container":"Header_container__LlI1p","headerElement":"Header_headerElement__+z8+p","headerElements":"Header_headerElements__eowz2","headerIcon":"Header_headerIcon__sdNLN"};